import request from '@/axios'

export function shortCourseList (customer_id, query,meta= null) {
  
  return request({
    url: `/course/list/short/${customer_id}?page=${meta.current_page}`,
    method: 'POST',
    data: query
  })
} 
export function scheduleTiming (query) {
  return request({
    url: '/schedule/timing/one-2-one',
    method: 'POST',
    data: query
  })
} 
export function courseEnroll (customer_id, query) {
  return request({
    url: `/course/enroll/multiple/${customer_id}`,
    method: 'POST',
    data: query
  })
} 

export function getRepositoryId (customer_id) {
  return request({
    url: `course/getRepositoryId/${customer_id}`,
    method: 'GET'
  })
}

export function enrolledStudentsList (platform_customer_id, query, payload) {
  return request({
    url: `/course/enrolled/student/details/${platform_customer_id}?limit=${query.limit}&page=${query.page}`,
    method: 'POST',
    data: payload
  })
}

export function enrolledStudentsDetails (platform_customer_id, query, payload) {
  return request({
    url: `course/enrolled/student/course_details/${platform_customer_id}?limit=${query.limit}&page=${query.page}`,
    method: 'POST',
    data: payload
  })
}

export function fetchAdmissionBySearch (query,page,sorting_obj) {
  return request({
    url: `course/enrolled/student/global_search?attribute=${sorting_obj.attribute}&direction=${sorting_obj.direction}&field_type=${sorting_obj.field_type}&page=${page}`,
    method: 'POST',
    data: query
  })
}